export default function LogoMark({ size = 30 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <path
                d="M6 11 L14.5 38 L24 17 L33.5 38 L42 11"
                stroke="#4ADE80"
                strokeWidth="3.2"
                strokeLinecap="square"
                strokeLinejoin="miter"
            />
            <circle cx="24" cy="9" r="2" fill="#4ADE80" />
        </svg>
    );
}
